import { CartNameSpace } from 'core/constant/CartNameSpace';
import { selectPageTypeIdFromBootstrap } from 'store/slice/bootstrap';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { createSelector } from '@reduxjs/toolkit';

export interface StateProps {
    pageTypeId: ActivitiesPageTypes;
}

export interface OwnProps {
    namespace: CartNameSpace;
}

export type HomeCrossSellPanelProps = StateProps & OwnProps;

export const mapStateToProps = createSelector(selectPageTypeIdFromBootstrap, (pageTypeId) => ({
    pageTypeId,
}));
